import { Link } from 'react-router-dom';
import { Download, BadgeCheck, Star, TicketPercent } from 'lucide-react';
import { formatRupiah, fileWUrl } from '../lib/api';
import RatingStars from './RatingStars';

export default function ProductCard({ product, testid, hasVoucher }) {
  const hasDiscount = product.discount_price && product.discount_price < product.price;
  const pct = hasDiscount ? Math.round((1 - product.discount_price / product.price) * 100) : 0;

  return (
    <Link to={`/produk/${product.slug}`} data-testid={testid || `product-card-${product.slug}`}
      className="group border border-border bg-white hover:border-brand-black transition-colors hover:-translate-y-1 hover:shadow-lg duration-200 flex flex-col">
      <div className="relative aspect-[4/3] overflow-hidden bg-zinc-100">
        {product.thumbnail ? (
          <img src={fileWUrl(product.thumbnail, 480)}
            srcSet={`${fileWUrl(product.thumbnail, 480)} 480w, ${fileWUrl(product.thumbnail, 1200)} 1200w`}
            sizes="(max-width: 640px) 50vw, (max-width: 1024px) 33vw, 300px"
            alt={product.name} loading="lazy"
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300" />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-zinc-300 font-heading font-black text-4xl">TS</div>
        )}
        {hasDiscount && (
          <span className="absolute top-3 left-3 bg-brand-red text-white text-xs font-semibold px-2 py-1" data-testid="discount-badge">
            -{pct}%
          </span>
        )}
        <div className="absolute bottom-3 left-3 flex gap-1">
          {(product.file_formats || []).slice(0, 3).map((f) => (
            <span key={f} className="bg-brand-black/80 text-white text-[10px] font-medium px-1.5 py-0.5 backdrop-blur-sm">{f}</span>
          ))}
        </div>
      </div>
      <div className="p-4 flex flex-col flex-1">
        <h3 className="font-heading font-bold text-sm leading-snug line-clamp-2 group-hover:text-brand-red transition-colors">{product.name}</h3>
        {product.seller_name && (
          <p className="text-xs text-zinc-500 mt-1.5 flex items-center gap-1 min-w-0 flex-wrap">
            <span className="truncate">{product.seller_name}</span>
            {product.seller_is_official ? (
              <span className="inline-flex items-center gap-0.5 text-[9px] font-semibold uppercase tracking-wide text-brand-red shrink-0" data-testid="official-badge-card">
                <BadgeCheck className="w-3 h-3" strokeWidth={2} /> Official Store
              </span>
            ) : (
              <>
                {product.seller_is_verified && (
                  <span title="Seller Terverifikasi" aria-label="Seller Terverifikasi" className="shrink-0" data-testid="verified-icon-card">
                    <BadgeCheck className="w-3 h-3 text-sky-600" strokeWidth={2} />
                  </span>
                )}
                {product.seller_is_top_seller && (
                  <span className="inline-flex items-center gap-0.5 text-[9px] font-semibold uppercase tracking-wide text-amber-600 shrink-0" data-testid="top-seller-badge-card">
                    <Star className="w-3 h-3 fill-amber-400 text-amber-400" strokeWidth={2} /> Top Seller
                  </span>
                )}
              </>
            )}
          </p>
        )}
        <div className="flex flex-wrap items-center justify-between gap-x-2 gap-y-1 mt-2">
          {product.has_rating_display
            ? <RatingStars rating={product.rating} count={product.rating_count} showCount={product.rating_count > 0} />
            : <span />}
          <span className="text-xs text-zinc-400 flex items-center gap-1 shrink-0" data-testid="sales-count">
            <Download className="w-3 h-3" strokeWidth={1.5} />{product.sales_count}
          </span>
        </div>
        <div className="mt-3 pt-3 border-t border-border">
          {hasDiscount && <p className="text-xs text-zinc-400 line-through">{formatRupiah(product.price)}</p>}
          <p className="font-heading font-bold text-base text-brand-black" data-testid="product-price">
            {formatRupiah(product.discount_price || product.price)}
          </p>
          {hasVoucher && (
            <span className="inline-flex items-center gap-1 mt-1.5 text-[10px] font-semibold uppercase tracking-wide text-brand-red" data-testid="voucher-badge-card">
              <TicketPercent className="w-3 h-3" strokeWidth={2} /> Voucher tersedia
            </span>
          )}
        </div>
      </div>
    </Link>
  );
}
